'use strict';

var translations = {
    warnings: {
        straightRow: "'asdf'처럼 키보드에서 연속된 배열은 피해주세요.",
        simpleRepeat: "'aaa' 및 'abcabc'처럼 반복되는 문자와 패턴은 피해주세요.",
        extendedRepeat: "'aaa' 및 'abcabc'처럼 반복되는 문자와 패턴은 피해주세요.",
        sequences: "'abc' 혹은 '6543'처럼 연속된 문자나 숫자는 피해주세요.",
        recentYears: "'2020'처럼 최근 연도는 피해주세요.",
        dates: '날짜는 피해주세요.',
        topTen: '흔한 비밀번호는 피해주세요.',
        topHundred: '흔한 비밀번호는 피해주세요.',
        common: '흔한 비밀번호는 피해주세요.',
        similarToCommon: '흔한 비밀번호는 피해주세요.',
        wordByItself: '단어 하나만 사용하는 것은 피해주세요.',
        namesByThemselves: '성과 이름을 단독으로 사용하는 것은 피해주세요.',
        commonNames: '성과 이름을 단독으로 사용하는 것은 피해주세요.',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: '두 단어 이상으로 길게 만들고, 흔한 문구는 피해주세요.',
        anotherWord:
            '단어를 몇 개 더 추가하세요.  흔하지 않거나 유추하기 어려운 단어면 더 좋습니다.',
        repeated: "'aaa' 및 'abcabc'처럼 반복되는 문자와 패턴은 피해주세요.",
        l33t: "'Apple' 대신 '@pple'처럼 예측 가능한 대체 표기는 피해주세요.",
        reverseWords: "'elppa'(apple 거꾸로)처럼 단어를 거꾸로 쓰는 것은 피해주세요.",
        allUppercase: '모두 대문자로 쓰는 것은 모두 소문자로 쓰는 것만큼 추측하기 쉽습니다.',
        dates: '날짜는 피해주세요.',
        associatedYears: '날짜는 피해주세요.',
        recentYears: "'2020'처럼 최근 연도는 피해주세요.",
        sequences: "'abc' 혹은 '6543'처럼 연속된 문자나 숫자는 피해주세요.",

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
